import { render } from "./Entertainment.vue?vue&type=template&id=117864ea"
import script from "./Entertainment.vue?vue&type=script&lang=js"
export * from "./Entertainment.vue?vue&type=script&lang=js"

import "./Entertainment.vue?vue&type=style&index=0&id=117864ea&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__